export default __webpack_public_path__ + "static/media/artwork-card-1.bbb536d3.png";